import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Services from "../components/Services";
import CTA from "../components/CTA";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-ink-950 text-white/90 selection:bg-blue selection:text-ink-950">
      <Nav />
      <Hero />
      <Services />
      <CTA />
      <Footer />
    </main>
  );
}
